import UiUtils from "@/assets/js/ui_utils.js";

export function getPeriodStartDate(period, selectedDate) {
  const startDate = new Date();
  startDate.setDate(1);
  switch(parseInt(period)) {
    case 1:
      startDate.setMonth(startDate.getMonth() - 3);
      break;
    case 2:
      startDate.setMonth(startDate.getMonth() - 6);
      break;
    case 3:
      startDate.setFullYear(startDate.getFullYear() - 1);
      break;
    case 4:
      startDate.setMonth(0);
      startDate.setDate(1);
      break;
    case 5:
      return new Date(selectedDate);
  }
  return startDate;
}

export function getPeriodComparable(period, selectedDate) {
  return getPeriodStartDate(period, selectedDate).getTime() / 1000;
}

export function sortByDateSymbolName(items, sortValue, dateField, symbolField, nameField) {
  switch(parseInt(sortValue)) {
    case 0:
      return UiUtils.sortByDate(items, dateField, true);
    case 1:
      return UiUtils.sortByDate(items, dateField, true).reverse();
    case 2:
      return UiUtils.sortByStringProperty(items, symbolField);
    case 3:
      return UiUtils.sortByStringProperty(items, symbolField).reverse();
    case 4:
      return UiUtils.sortByStringProperty(items, nameField);
    case 5:
      return UiUtils.sortByStringProperty(items, nameField).reverse();
    default:
      return items;
  }
}

export function sortTransactionsBySelection(items, sortValue) {
  switch(parseInt(sortValue)) {
    case 0:
      return UiUtils.sortByDate(items, "ts", true);
    case 1:
      return UiUtils.sortByDate(items, "ts", true).reverse();
    case 2:
      return UiUtils.sortByDoubleProperty(items, "am");
    case 3:
      return UiUtils.sortByDoubleProperty(items, "am").reverse();
    default:
      return items;
  }
}

function getTransferDirectionOrder(transfer) {
  const transferType = transfer?.tt?.toString().toUpperCase();
  if ("S" === transferType) {
    return 0;
  }
  if ("B" === transferType) {
    return 1;
  }
  return 2;
}

export function sortTransfersBySelection(items, sortValue) {
  const parsedSortValue = parseInt(sortValue);
  const isDescending = 1 === parsedSortValue || !Number.isInteger(parsedSortValue);
  if (0 !== parsedSortValue && 1 !== parsedSortValue) {
    return Number.isInteger(parsedSortValue)
      ? sortByDateSymbolName(items, parsedSortValue, "ts", "sc", "nEN")
      : sortTransfersBySelection(items, 1);
  }

  const sortedItems = items.sort((a, b) => {
    const timestampDifference = isDescending
      ? parseInt(b?.ts || 0) - parseInt(a?.ts || 0)
      : parseInt(a?.ts || 0) - parseInt(b?.ts || 0);
    if (0 !== timestampDifference) {
      return timestampDifference;
    }

    const sameSymbol = a?.sc?.toString().toLowerCase() === b?.sc?.toString().toLowerCase();
    if (sameSymbol) {
      const directionDifference = getTransferDirectionOrder(a) - getTransferDirectionOrder(b);
      return isDescending ? -directionDifference : directionDifference;
    }

    return 0;
  });

  return sortedItems;
}
